const SECTION_ROUTE_MAP = {
  ReviewsPage: new Set([
    'ReviewsPage',
    'ReviewDetailPage',
    'ReviewDetailPageById',
    'ReviewDetailPageWithBrand',
    'AddMyReviewPage',
    'EditMyReviewPage',
  ]),
  ResalePage: new Set(['ResalePage', 'ProductPage']),
  NewListingPage: new Set(['StartSellingSignupPage']),
  EditListingPage: new Set(['StartSellingSignupPage']),
};

const SECTION_PATH_PREFIX_MAP = {
  '/reviews': ['/reviews', '/review'],
  '/resale': ['/resale', '/product'],
  '/start-selling': ['/start-selling'],
};

const basePageName = currentPage => {
  return typeof currentPage === 'string' ? currentPage.split(':')[0] : currentPage;
};

const normalizePath = path => {
  if (!path || typeof path !== 'string') {
    return '';
  }

  const withoutQuery = path.split('?')[0].split('#')[0];
  if (!withoutQuery) {
    return '';
  }

  return withoutQuery.length > 1 && withoutQuery.endsWith('/')
    ? withoutQuery.slice(0, -1)
    : withoutQuery;
};

export const isTopbarLinkActive = (targetPage, currentPage) => {
  if (!targetPage || !currentPage) {
    return false;
  }

  const currentBase = basePageName(currentPage);
  if (currentBase === targetPage) {
    return true;
  }

  const sectionPages = SECTION_ROUTE_MAP[targetPage];
  return sectionPages ? sectionPages.has(currentBase) : false;
};

export const isTopbarHrefActive = (targetHref, currentPathname) => {
  const targetPath = normalizePath(targetHref);
  const currentPath = normalizePath(currentPathname);

  if (!targetPath || !currentPath) {
    return false;
  }

  if (targetPath === currentPath) {
    return true;
  }

  const sectionPrefixes = SECTION_PATH_PREFIX_MAP[targetPath];
  return sectionPrefixes
    ? sectionPrefixes.some(prefix => currentPath === prefix || currentPath.startsWith(`${prefix}/`))
    : false;
};
